import { Controller } from "@hotwired/stimulus"
import { ethers } from "ethers";

// Connects to data-controller="metamask"
export default class extends Controller {
  connect() {
  }

  async login(event) {
    event.preventDefault();
    if (!window.ethereum) {
      toast('Please install metamask', {
        type: 'error',
        description: 'You need metamask to use SomeGorillas Products',
      })
      return;
    }

    showLoading("Metamask Sign In")
    try {
      const form = this.element

      if (window.ethereum.selectedAddress == "") {
        await window.ethereum.request({
          method: "wallet_requestPermissions",
          params: [{ eth_accounts: {} }],
        })
      }

      const provider = new ethers.BrowserProvider(window.ethereum)
      const signer = await provider.getSigner()
      const address = await signer.getAddress()
      const nonce = form.dataset.nonce

      const message = `SomeGorillas Login\n${nonce}`
      const signature = await signer.signMessage(message)

      form.elements["address"].value = address
      form.elements["signature"].value = signature

      form.submit()
    } catch (e) {
      console.error(e)
      console.log(e.message)
      hideLoading()
      toast('User rejected metamask connect', { type: 'error' })
    }
  }
}
